import { PageLoading } from 'components/loading'
import { useHistoricoAtividadeColetivaQuery } from 'graphql/hooks.generated'
import { IdadeOrigemAtendimento } from 'view/atendimentos/detail/historico/model/model-historico'

import HistoricoNoDetailAvailable from '../../HistoricoNoDetailAvailable'
import { convertHistoricoAtividadeColetivaDwSaudeToHistoricoAtividadeColetivaSaude } from '../converter-historicoAtividadeColetiva'
import HistoricoAtividadeColetivaPanelSaude from './HistoricoAtividadeColetivaPanelSaude'

interface HistoricoAtividadeColetivaDwPanelSaudeProps {
  readonly uuidRegistro: ID
  readonly idadeOrigemAtendimento: IdadeOrigemAtendimento
  readonly cpfOuCnsCidadao: string
}

export default function HistoricoAtividadeColetivaDwPanelSaude({
  uuidRegistro,
  idadeOrigemAtendimento,
  cpfOuCnsCidadao,
}: HistoricoAtividadeColetivaDwPanelSaudeProps) {
  const {
    data: { historicoAtividadeColetiva: atividadeColetiva },
    loading,
  } = useHistoricoAtividadeColetivaQuery({
    variables: {
      input: {
        uuidRegistro,
        cpfOuCnsCidadao,
        isOrigemPec: false,
      },
    },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!atividadeColetiva) {
    return <HistoricoNoDetailAvailable />
  } else {
    return (
      <HistoricoAtividadeColetivaPanelSaude
        atividadeColetiva={convertHistoricoAtividadeColetivaDwSaudeToHistoricoAtividadeColetivaSaude(atividadeColetiva)}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        isFonteDadosPec={false}
      />
    )
  }
}
